import { Component, Input } from '@angular/core'
import { Advert } from '@model/entities/advert'
import { UserService } from '@service/user/user.service'
import { appConfig } from '@configuration/app-config';
import { RestService } from '@service/rest/rest.service';
import { MobileService } from '@service/mobile.service';
import { EntityDisplayComponent } from '@component/entity-display-component';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { StateService } from '@service/state.service';
import { ScrollService } from '@service/scroll.service';

@Component({
  selector: 'app-advert-display',
  templateUrl: './advert-display.component.html',
  styleUrls: ['./advert-display.component.scss'],
})
export class AdvertDisplayComponent extends EntityDisplayComponent {

  protected entityTypeIdentifier: EntityTypeIdentifier = "advert"

  public appConfig = appConfig

  public loading: boolean = false

  // disables like / share etc.
  @Input()
  public live: boolean = true


  public set entity(entity: Advert) {
    this._entity = entity
    this.computeAuthor()
  }
  public get entity() {
    return this._entity
  }
  private _entity: Advert = null

  constructor(
    public UserService: UserService,
    private restService: RestService,
    public mobileService: MobileService,
    public EntityTypeConfigService: EntityTypeConfigService,
    public StateService: StateService,
    public ScrollService: ScrollService,
  ) {
    super(
      EntityTypeConfigService,
      UserService
    )
  }

  public openAffiliateLink() {
    let tracking = this.entity.affiliate_link_tracking;

    let accessTokenUrl = ""
    let accesstoken = this.UserService.getAccessToken()

    if (accesstoken)
      accessTokenUrl = "&access_token=" + accesstoken;

    let win = window.open(this.restService.getApiUrl() + "goods/redirectAffiliate/?affiliate_link_tracking=" + tracking + "" + accessTokenUrl, '_blank')
    win.focus()
  }

  public edit() {
    this.StateService.goto('/market/edit/' + this.entity.id)
      .then(() => { this.ScrollService.scrollToTop() })
  }
}